import { CountryThunkGenerator } from 'utility/redux/thunkGenerator';

const filterDetails = (() => {
  const apiName = 'filterDetails';
  const generatedHttpThunk = new CountryThunkGenerator(apiName);
  generatedHttpThunk.resource = `country-management/filter-details`;
  return generatedHttpThunk.generateThunk();
})();

export default filterDetails;
